module.exports = __webpack_public_path__ + "img/WalkerGrey.4b2937a5.svg";